import { LogStatus } from "@/constant";

export const isErrorCode = (statusCode: string) => {
  return Object.keys(LogStatus).includes(statusCode);
};
